import React from 'react';
import PropTypes from 'prop-types';
import removeIcon from 'img/remove.png'

const ImageItem = (props) => {
  const { classes,image, onDeleteButton, usingDelete } = props || {}
  return (
    <div className={classes.relativeimgbox}>
      <img
        src={image?.src || image?.url}
        alt={image.name}
        className={classes.imgPrev}
   
      />
      {usingDelete && (
        <button type='button' className={classes.deleteBtn} onClick={onDeleteButton} aria-label='delete' >
          <img src={removeIcon} className={classes.deleteButton} alt='remove' />
        </button>
      )}

    </div>
  );
};

ImageItem.propTypes = {
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    name: PropTypes.string,
    key: PropTypes.string,
  }).isRequired,
};

export default ImageItem;
